import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import { InboxItem } from "@/services";
import { BasicRoutePath } from "@/constants";

export const useSearchSuggests = ({
  onResetData,
  onSetApprovalSuggests,
  onSetSearchQuery,
}: {
  onResetData: () => void;
  onSetApprovalSuggests: (value: null) => void;
  onSetSearchQuery: (value: string) => void;
}) => {
  const { tab } = useParams();
  const navigate = useNavigate();

  const handleQueryChange = useCallback(
    (query: string) => {
      onSetSearchQuery(query);
      onSetApprovalSuggests(null);
    },
    [onSetApprovalSuggests, onSetSearchQuery],
  );

  const handleSelectSuggest = useCallback(
    (item: InboxItem) => {
      onSetSearchQuery(item.CompanyName);
    },
    [onSetSearchQuery],
  );

  const handleQueryClear = useCallback(() => {
    onSetSearchQuery("");
    navigate(`${BasicRoutePath.Approvals}/${tab}`);
    onSetApprovalSuggests(null);
    onResetData();
  }, [navigate, onResetData, onSetApprovalSuggests, onSetSearchQuery, tab]);

  return {
    onSelectSuggest: handleSelectSuggest,
    onQueryChange: handleQueryChange,
    onQueryClear: handleQueryClear,
  };
};
